export enum LineItemType {
  ActualDemand = 'Actual Demand',
  BilledDemand = 'Billed Demand',
  Demand = 'Demand',
  Charges = 'Charges',
  OnsiteGeneration = 'Onsite Generation',
  SolarGridPurchased = 'Solar Grid Purchased',
  SolarOnsiteExcess = 'Solar Onsite Excess',
  Taxes = 'Taxes',
  Usage = 'Usage',
  Other = 'Other',
}

export enum LineItemDesciptionType {
  ReversedAllocation = 'Reversed Allocation',
}

export const DemandLineItemTypes = [
  LineItemType.ActualDemand,
  LineItemType.BilledDemand,
  LineItemType.Demand,
];

export const UsageLineItemTypes = [LineItemType.Usage];
